// Ubicación en el repo: src/components/SpeechCurveSVG.jsx
// Curva de logoaudiometría — mismo layout que drawSpeechCurveSVG() del
// prototipo (línea ~2032): un punto por oído (dB en X, % en Y), con una
// línea punteada vertical hasta el eje.
const W = 560;
const H = 320;
const PAD_L = 48;
const PAD_R = 22;
const PAD_T = 18;
const PAD_B = 38;
const PLOT_W = W - PAD_L - PAD_R;
const PLOT_H = H - PAD_T - PAD_B;
const MONO = "'JetBrains Mono', monospace";

function xFor(db) {
  return PAD_L + (db / 120) * PLOT_W;
}
function yFor(pct) {
  return PAD_T + ((100 - pct) / 100) * PLOT_H;
}

function Point({ entry, color }) {
  if (!entry || entry.percent == null || entry.db == null) return null;
  const x = xFor(entry.db);
  const y = yFor(entry.percent);
  return (
    <>
      <line x1={x} y1={PAD_T} x2={x} y2={H - PAD_B} stroke={color} strokeWidth={1} strokeDasharray="3,3" opacity={0.4} />
      <circle cx={x} cy={y} r={6} fill={color} />
    </>
  );
}

export default function SpeechCurveSVG({ logoOd, logoOi }) {
  return (
    <svg viewBox={`0 0 ${W} ${H}`} width="100%" style={{ maxWidth: 580 }}>
      {[0, 20, 40, 60, 80, 100].map((pct) => {
        const y = yFor(pct);
        return (
          <g key={pct}>
            <line x1={PAD_L} y1={y} x2={W - PAD_R} y2={y} stroke="#DCE3E5" strokeWidth={1} />
            <text x={PAD_L - 8} y={y + 4} fontSize={11} textAnchor="end" fill="#5B6B6E" fontFamily={MONO}>
              {pct}%
            </text>
          </g>
        );
      })}
      {[0, 20, 40, 60, 80, 100, 120].map((db) => {
        const x = xFor(db);
        return (
          <g key={db}>
            <line x1={x} y1={PAD_T} x2={x} y2={H - PAD_B} stroke="#DCE3E5" strokeWidth={1} />
            <text x={x} y={H - PAD_B + 17} fontSize={10.5} textAnchor="middle" fill="#5B6B6E" fontFamily={MONO}>
              {db}
            </text>
          </g>
        );
      })}
      <Point entry={logoOd} color="#C4453C" />
      <Point entry={logoOi} color="#2563A6" />
    </svg>
  );
}
